import { render, staticRenderFns } from "./DisposeRow.vue?vue&type=template&id=2c5f9106"
import script from "./DisposeRow.vue?vue&type=script&lang=js"
export * from "./DisposeRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports